import clsx from "clsx"
import PropTypes from "prop-types"
import { Controller, useFormContext } from "react-hook-form"

const Select = ({ label, id, className, options, disabled, ...inputProps }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext()
  return (
    <Controller
      control={control}
      name={id}
      render={({
        field: { value, onChange, onBlur },
        fieldState: { error },
      }) => {
        return (
          <div
            className={clsx(
              "flex flex-col mb-4 w-full relative",
              className && className,
            )}
          >
            <label
              htmlFor={id}
              className="mt-4 mb-2 text-xs text-brand-secondary font-semibold"
            >
              {label}
            </label>
            <select
              disabled={disabled}
              id={id}
              className={clsx(
                "border border-gray1 rounded-lg px-4 flex justify-between items-center h-full bg-[transparent] triangle-down-select-icon search-input bg-gray1 text-[12px]",
                className && className,
              )}
              onChange={onChange}
              value={value}
            >
              <option value="" disabled>
                Select a type
              </option>

              {options?.map((option) => {
                return (
                  <option key={option.id} value={option.id}>
                    {option.name}
                  </option>
                )
              })}
            </select>
            {error && (
              <p className="text-xs text-red-500 absolute -bottom-5">
                {error?.message}
              </p>
            )}
          </div>
        )
      }}
    />
  )
}

Select.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  options: PropTypes.array,
}

export default Select
